import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";
import { AuthService } from ".";
import { MODULE } from "@/config/modules";
import { MollieTerminal, MollieTerminalPayment } from "@/utils/mollie-terminal/mollie-terminal";
import { MollieTerminalSettings } from "@/utils/mollie-terminal/mollie-terminal-settings";

function getSettingsKey():string{
	return `mollie-terminal-settings-${AuthService.wfDossier.id}`;
}

export class MollieTerminalService {
	public static readonly url:string = `${ServerConfig.host}/mollie-terminal`;

	public static async getTerminals():Promise<MollieTerminal[]> {
		let result = await Axios.get(`${this.url}/terminals`);
		return ((result.data || []) as any[]).map(r => new MollieTerminal(r));
	}

	public static async createPayment(amount:number, terminalId:string, reference:string):Promise<MollieTerminalPayment> {
		let result = await Axios.post(`${this.url}/payments`, {
			Amount: amount,
			TerminalID: terminalId,
			Reference: reference
		});
		return new MollieTerminalPayment(result.data);
	}

	public static async getPayment(paymentId:string):Promise<MollieTerminalPayment> {
		let result = await Axios.get(`${this.url}/payments/${encodeURIComponent(paymentId)}`);
		return new MollieTerminalPayment(result.data);
	}

	public static async cancelPayment(paymentId:string):Promise<MollieTerminalPayment> {
		let result = await Axios.delete(`${this.url}/payments/${encodeURIComponent(paymentId)}`);
		return new MollieTerminalPayment(result.data);
	}

	public static async waitForFinalStatus(payment:MollieTerminalPayment):Promise<MollieTerminalPayment> {
		while (!payment.isFinal) {
			await new Promise(resolve => setTimeout(resolve, 2000));
			payment = await this.getPayment(payment.ID);
		}
		return payment;
	}

	public static getSettings():MollieTerminalSettings {
		let storedJsonString = localStorage.getItem(getSettingsKey());
		let storedSettings = null;
		if (storedJsonString) {
			storedSettings = JSON.parse(storedJsonString);
		}
		return new MollieTerminalSettings(storedSettings);
	}

	public static setSettings(settings:MollieTerminalSettings){
		localStorage.setItem(getSettingsKey(), JSON.stringify(settings.getJSON()));
	}

	public static hasModule():boolean {
		return AuthService.hasModule(MODULE.MOLLIE);
	}
}
